const UploadIcon: React.FC<Partial<{ className: string; fill: string }>> = ({
  className,
  fill,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.13244 5.14049C6.6105 5.56993 7.13717 5.27419 7.30328 5.09998L9.24792 3.00949V15.0501C9.24792 15.5079 9.61659 15.8765 10.0744 15.8765C10.5322 15.8765 10.9009 15.5079 10.9009 15.0501V3.00544L12.8455 5.09593C13.1575 5.43219 13.6801 5.44839 14.0163 5.13644C14.3526 4.82449 14.3688 4.30186 14.0569 3.9656L10.678 0.335603C10.52 0.169498 10.3013 0.0722656 10.0744 0.0722656C9.84347 0.0722656 9.6247 0.169498 9.47075 0.335603L6.09193 3.9656C5.77998 4.30591 5.79213 4.83664 6.13244 5.14049Z"
        fill={fill || "#CAC2C3"}
      />
      <path
        d="M19.1735 13.2026C18.7157 13.2026 18.3471 13.5713 18.3471 14.0291V18.2749H1.80138V14.0291C1.80138 13.5713 1.43271 13.2026 0.974911 13.2026C0.517109 13.2026 0.148438 13.5713 0.148438 14.0291V19.1014C0.148438 19.5592 0.517109 19.9279 0.974911 19.9279H19.1735C19.6313 19.9279 20 19.5592 20 19.1014V14.0291C20 13.5713 19.6313 13.2026 19.1735 13.2026Z"
        fill={fill || "#CAC2C3"}
      />
    </svg>
  );
};

export default UploadIcon;
